export class Tracker {
  private _setSticky: (isSticky: boolean) => void;
  private _isSticky: boolean = false;
  private _isTracking: boolean = false;
  private _viewport: any;

  private _updateIsSticky() {
    const isSticky = (this._viewport.scrollTop || this._viewport.scrollY || 0) > 0;
    this._updateSticky(isSticky);
  }

  private _updateSticky(isSticky: boolean) {
    if (this._isSticky !== isSticky) {
      this._isSticky = isSticky;
      this._setSticky(isSticky);
    }
  }

  private _onScroll = () => {
    window.requestAnimationFrame(() => this._updateIsSticky());
  };

  public update(isSticky: boolean, setSticky: (isSticky: boolean) => void) {
    this._viewport = window;

    if (isSticky) {
      this._setSticky = setSticky;

      if (!this._isTracking) {
        this._isTracking = true;

        this._viewport.addEventListener("scroll", this._onScroll);

        this._onScroll();
      }
    } else if (this._isTracking) {
      this._viewport.removeEventListener("scroll", this._onScroll);

      this._isTracking = false;
      this._updateSticky(false);
    }
  }

  public destroy() {
    if (this._isTracking) {
      this._viewport.removeEventListener("scroll", this._onScroll);
      this._isTracking = false;
      this._updateSticky(false);
    }
  }
}
